module.exports = __webpack_public_path__ + "static/mongodb-edf8e26c874f40b88774c83172fad953.png";